import { use } from 'react';

import { MainLayoutContext } from './MainLayoutContext';

export const useMainLayoutContext = () => {
  const ctx = use(MainLayoutContext);

  if (!ctx) {
    throw new Error('useMainLayoutContext must be used within a MainLayoutProvider');
  }

  return ctx;
};
